// On-device TEXT (bib/OCR) pipeline config — Phase 1 (spec §8). Behind a flag and
// OFF by default: enabling it makes the worker run DBNet+CRNN on person crops and add
// `text` to the sidecar, but the SERVER STILL OCRs (Phase 1 changes nothing server-side
// — the sidecar text is emitted only so we can measure real-world parity before the
// Phase-2 trust hatch trusts it). So this is zero-risk to turn on.
//
// The model-version string MUST equal the future prescanned.js KNOWN_TEXT_MODELS entry
// (spec §4b) so Phase 2 can trust exactly the sidecars this pipeline produced.
export const TEXT_MODEL_VERSION = 'ppocr-en-det-v3-rec-v4@1';

// Asset URLs (served like the YOLO models from public/models/). The det model is the
// exact en_PP-OCRv3_det export, rec the en_PP-OCRv4_rec export, dict PaddleOCR's
// built-in en_dict.txt — all produced + sha-pinned by the Phase-0 parity CI.
export const TEXT_DET_MODEL_URL = '/models/ppocr-en-det-v3.onnx';
export const TEXT_REC_MODEL_URL = '/models/ppocr-en-rec-v4.onnx';
export const TEXT_DICT_URL = '/models/ppocr-en-dict.txt';

// Whether on-device text OCR runs at all. Pure so it's unit-testable; the browser
// wrapper reads the env flag + a localStorage per-tester override. Phase 2: ON by
// default (the server now trusts the on-device text for the known model version). It
// only actually runs for people/text galleries (wantText = wantPeople), so faces-only
// galleries are unaffected. Disable per-tester with ph_scan_text='0' or deploy-wide
// with VITE_SCAN_TEXT=false.
export function resolveTextScan({ envFlag, lsFlag } = {}) {
  // Explicit OFF wins; otherwise default ON.
  const off =
    envFlag === false || envFlag === 'false' || envFlag === '0' ||
    lsFlag === '0' || lsFlag === 'false';
  return !off;
}

const ls = (key) => {
  try {
    return typeof localStorage !== 'undefined' ? localStorage.getItem(key) : null;
  } catch {
    return null;
  }
};

export function textScanEnabled() {
  return resolveTextScan({
    envFlag: import.meta.env?.VITE_SCAN_TEXT,
    lsFlag: ls('ph_scan_text'),
  });
}
